<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <template v-if="qa_sub_categories">
          <ul class="card-outlined md:py-2 md:px-4">
            <li v-for="qa_sub_category in qa_sub_categories" :key="qa_sub_category.id" class="px-1 pt-1.5 pb-2">
              <div class="flex items-center justify-between px-2 mb-2">
                <div>
                  <h1 class="text-green-600 text-2xl">{{qa_sub_category.name}}</h1>
                  <ul class="md:py-2 md:px-4">
                    <li v-for="qa_list in qa_sub_category.qa_lists" :key="qa_list.id" class="px-1 pt-1.5 pb-2">
                      <router-link
                        :to="`/qa/list/`+ qa_list.id"
                      >
                        <div class="flex items-center justify-between border-gray-300 border-b px-2 mb-2">
                          <div class="hover:text-gray-400">
                            {{qa_list.question_title}}
                          </div>
                        </div>
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </template>
        <template v-else>
          ページが見つかりませんでした。
        </template>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue'
import { useStore } from '@/store/index'
import { useRoute } from 'vue-router'
import { axios } from '@/plugins/axios'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const qa_sub_categories = ref()

    onMounted(() => {
      axios
        .get(`/qa/category/${route.params.qa_sub_category_id}`)
        .then(response => {
          qa_sub_categories.value = response.data.payload
        })
    })

    return {
      store,
      qa_sub_categories
    }
  }
})
</script>
